let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2w2jh")).then(() => parcelRequire('2LlB2'));